import EMPTY_FIELD_VALUE from '../../config/defaultValues';

export const remainingBudgetValueFormatter = ({ value }) => (value !== null ? `$${value}` : EMPTY_FIELD_VALUE);
